export default __webpack_public_path__ + "images/22_1_image.jpg";